// @flow
import React, { type ElementRef } from 'react';
import i18n from 'app/common/lib/i18n';
import { MultiTreatmentExp } from 'app/common/lib/experiment';
import {
  MASONRY_CONSTS,
  type InterestObj,
} from 'app/common/react/components/growth/activation/NuxConst/NuxConst';
import {
  withRequestContext,
  type RequestContextType,
} from 'app/common/react/components/RequestContext';
import { Masonry, Spinner } from 'gestalt';

type Props = {
  requestContext: RequestContextType,
  interests: Array<InterestObj>,
  handleInterestClick: () => void,
  InterestComponentToRender: (number, InterestObj) => React.Component<any>,
  gridContainerRef: ElementRef<any>,
};

const InterestMasonry = (props: Props) => {
  const { requestContext, interests, InterestComponentToRender, gridContainerRef } = props;
  const showSpinner = interests && interests.length < 1;

  const MASONRY_PLATFORM_CONSTS = MASONRY_CONSTS.DESKTOP;

  const hoverStateExp = new MultiTreatmentExp(requestContext, 'web_nux_picker_hover_state');
  const borderOffset =
    hoverStateExp.check('enabled_border') || hoverStateExp.check('employees') ? 8 : 0;

  return (
    <div style={MASONRY_PLATFORM_CONSTS.STYLES}>
      {/* $FlowFixMe: new errors found from flow 0.96 upgrade */}
      <Masonry
        columnWidth={MASONRY_PLATFORM_CONSTS.COLUMN_WIDTH + borderOffset}
        comp={InterestComponentToRender}
        // Remove pagination until ReNUX follow endpoints also have pagination
        loadItems={() => {}}
        gutterWidth={MASONRY_PLATFORM_CONSTS.GUTTER_WIDTH - borderOffset}
        items={interests}
        minCols={MASONRY_PLATFORM_CONSTS.COLUMNS}
        scrollContainer={() => gridContainerRef || window}
      />
      <Spinner accessibilityLabel={i18n._('Loading topics')} show={showSpinner} />
    </div>
  );
};

export default withRequestContext(InterestMasonry);
